import { combineReducers } from "redux";
import config from './templateConfig/';
import Navigation from './navigation/';
import todoReducer from "./todo/";
import Notes from "./note/";
import chatReducer from "./chat/";
import emailReducer from "./email/";
import Icons from "./icons/";
import authReducer from './auth/';
import projectsReducer from './projects/';
import usersReducer from './users/';
import suppliersReducer from './suppliers/';
import settlementsReducer from './settlements/';

const rootReducer = combineReducers({
  config,
  Navigation,
  todoApp: todoReducer,
  noteApp: Notes,
  chatApp: chatReducer,
  emailApp: emailReducer,
  Icons,
  auth: authReducer,
  projectsApp: projectsReducer,
  usersApp: usersReducer,
  suppliersApp: suppliersReducer,
  settlementsApp: settlementsReducer
});

export default rootReducer;